/**
 * Markdown → 純文字工具
 */

/**
 * 移除 markdown 語法，回傳純文字
 */
export const stripMarkdown = (md) => {
  if (!md) return '';
  return md
    // 移除圖片 ![alt](url)
    .replace(/!\[.*?\]\(.*?\)/g, '')
    // 移除連結但保留文字 [text](url) → text
    .replace(/\[([^\]]*)\]\(.*?\)/g, '$1')
    // 移除 code block (``` ... ```)
    .replace(/```[\s\S]*?```/g, '')
    // 移除 inline code
    .replace(/`([^`]*)`/g, '$1')
    // 移除標題 # 符號
    .replace(/^#{1,6}\s+/gm, '')
    // 移除粗斜體
    .replace(/\*{1,3}(.*?)\*{1,3}/g, '$1')
    .replace(/_{1,3}(.*?)_{1,3}/g, '$1')
    // 移除刪除線
    .replace(/~~(.*?)~~/g, '$1')
    // 移除 blockquote
    .replace(/^\s*>\s?/gm, '')
    // 移除 list markers (-, *, numbered)
    .replace(/^\s*[-*+]\s+/gm, '')
    .replace(/^\s*\d+\.\s+/gm, '')
    // 移除 horizontal rules
    .replace(/^[-*_]{3,}\s*$/gm, '')
    // 移除 HTML tags
    .replace(/<[^>]+>/g, '')
    // 壓縮連續換行為單一空格
    .replace(/\n{2,}/g, ' ')
    // 換行轉空格
    .replace(/\n/g, ' ')
    // 壓縮連續空格
    .replace(/\s{2,}/g, ' ')
    .trim();
};

/**
 * 截取描述摘要
 * @param {string} md - Markdown 格式的描述
 * @param {number} maxLen - 最大字元數
 */
export const getDescriptionExcerpt = (md, maxLen = 100) => {
  const text = stripMarkdown(md);
  if (text.length <= maxLen) return text;
  return text.slice(0, maxLen) + '...';
};

/**
 * 判斷 hex 色碼是否為淺色（需要深色文字）
 * @param {string} hex - 色碼，如 '#eeeeee'
 * @returns {boolean}
 */
export const isLightColor = (hex) => {
  if (!hex) return false;
  const h = hex.replace('#', '');
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  // 相對亮度公式
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.7;
};

/**
 * 根據背景色回傳適合的文字色
 */
export const getTextColorForBg = (bgHex) => {
  return isLightColor(bgHex) ? '#444' : '#fff';
};

